export const duplicateEntities = [
  'Zolo-T12',
  'Zolo-T14',
  'Zolo-T17',
  'Zolo-T18',
  'Zolo-T19',
  'Zolo-T20',
  'Zolo-T21',
  'Zolo-T22',
  'Zolo-T23',
  'Zolo-T24',
  'Zolo-T25',
  'Zolo-T26',
  'Zolo-T27',
  'Zolo-T28',
  'Zolo-T29',
]


// WEBPACK FOOTER //
// ./src/constants/duplicateEntities.js